var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "129px",
    height: "116px",
    viewBox: "0 0 129 116",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "api") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.54957225,63.3034931 C-0.516524083,59.7103739 -0.516524083,55.2896261 1.54957225,51.6965069 L28.0056838,5.80349307 C30.0717801,2.21037388 33.9016173,0 38.0438884,0 L90.9561116,0 C95.0983827,0 98.9181413,2.21037388 100.994316,5.80349307 L127.450428,51.6965069 C129.516524,55.2896261 129.516524,59.7103739 127.450428,63.3034931 L100.994316,109.196507 C98.9282199,112.789626 95.0983827,115 90.9561116,115 L38.0438884,115 C33.9016173,115 30.0717801,112.779533 28.0056838,109.196507 L1.54957225,63.3034931 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Product-Logos",
    transform: "translate(-678.000000, -349.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "api",
    transform: "translate(678.000000, 342.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BASE",
    transform: "translate(0.000000, 7.054688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#4386FB",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4079DB",
    opacity: 0.90404212,
    mask: "url(#mask-2)",
    points: "123.457031 72.9857812 93.8777344 43.3964062 78.0248438 49.0502344 83.9003906 54.9257812 84.2632031 56.9615625 72.4919531 45.2003906 62.0308594 46.5710156 58.5539063 53.938125 50.0782031 45.4523437 37.5813281 47.6997656 34.9610156 71.4035156 78.9016406 115.354219 98.3221875 115.172812"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shadow",
    transform: "translate(34.265625, 50.390625)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "art",
    transform: "translate(34.265625, 50.390625)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.17789062,0.131015625 C3.40640625,0.131015625 0.634921875,2.9025 0.634921875,5.67398438 L0.634921875,28.0877344 L6.17789062,28.0877344 L6.17789062,17.0017969 L11.7208594,17.0017969 L11.7208594,28.0877344 L17.2638281,28.0877344 L17.2638281,5.67398438 C17.2638281,2.9025 14.4923437,0.131015625 11.7208594,0.131015625 L6.17789062,0.131015625 L6.17789062,0.131015625 Z M6.17789062,11.4588281 L6.17789062,5.66390625 L11.7208594,5.66390625 L11.7208594,11.4588281 L6.17789062,11.4588281 L6.17789062,11.4588281 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8536719,0.131015625 C26.0821875,0.131015625 23.3107031,2.9025 23.3107031,5.67398437 L23.3107031,28.0877344 L28.8536719,28.0877344 L28.8536719,17.0017969 L34.3966406,17.0017969 C37.168125,17.0017969 39.9396094,14.2303125 39.9396094,11.4588281 L39.9396094,5.66390625 C39.9396094,2.89242187 37.168125,0.1209375 34.3966406,0.1209375 L28.8536719,0.1209375 L28.8536719,0.131015625 Z M28.8536719,11.4588281 L28.8536719,5.66390625 L34.3966406,5.66390625 L34.3966406,11.4588281 L28.8536719,11.4588281 L28.8536719,11.4588281 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "48.9998438 5.67398438 48.9998438 22.5447656 43.7088281 22.5447656 43.7088281 28.0877344 59.8338281 28.0877344 59.8338281 22.5447656 54.5428125 22.5447656 54.5428125 5.67398438 59.8338281 5.67398438 59.8338281 0.131015625 43.7088281 0.131015625 43.7088281 5.67398438"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.a9634b75e82c964d4e4d828f21fcf444.svg";
export { ForwardRef as ReactComponent };